import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { RoomPriceRankDailyStatusInputZodSchemaType } from "./validation-schema";

const _excludeKeys = [
	"hotelID", //
	// "statuses",
] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

type QueryData = undefined;

export type ProductRoomPriceRankDailyStatusFormModel = AutoGeneratorForFormModel<
	RoomPriceRankDailyStatusInputZodSchemaType, //
	ExcludeKeys,
	QueryData
>;
